import { createApi } from "@reduxjs/toolkit/query/react";
import { api } from "../../../api/Api.jsx";

export const Indebdenet = createApi({
    reducerPath: 'Indebdenet',
    baseQuery: api,  
    tagTypes: ['Indebdenet'],
    endpoints: (build) => ({
        getIndebdenet: build.query({
            query: (body) => `students/get_indebted_students/`,
            providesTags: ['tagTypes'],

        }),
        addIndebdenet: build.mutation({
            query: (body) => ({
                url: `student_discounts/`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["tagTypes"],
        }),
    }),
});

export const {
useGetIndebdenetQuery

} = Indebdenet;